import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ComboObservacionesEyaculadoEliminado/addComboObservacionesEyaculadoEliminado`, method: 'POST', body: values, token: token})
}
